// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__TR-yr","box":"WorkspacesBox_box__25tPQ","node":"WorkspacesBox_node__7ooWP"};